import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction } from '!core/redux';
import { getFundType } from '»utils/funds';

const initialState = {
  primary: { data: [], isLoading: false },
  market: { data: [], selectedTitle: {}, isLoading: false },
  currentTab: {
    ord: 0,
    name: '',
  },
  webAreas: [],
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

const updateState = ({ state, fundsDetails, isLoading, fundsList }) => {
  const fundType = getFundType(fundsDetails);

  if (fundType === 'fundsPrimary') {
    if (fundsList) {
      state.primary.data = fundsList;

      state.primary.data.forEach((fund) => {
        fund.startDate = fund.ordInitialDate;
        fund.endDate = fund.ordLimitAceptedDate;
        delete fund.ordInitialDate;
        delete fund.ordLimitAceptedDate;
      });
    }

    state.primary.isLoading = isLoading;
  } else {
    if (fundsList) {
      state.market.data = fundsList;
      state.market.selectedTitle = { ...fundsList[0] };
    }

    state.market.isLoading = isLoading;
  }
};

const getCurrentTabName = (webAreaTemplate) => {
  if (webAreaTemplate === 'FUNDS_QUOTES_PRI') return 'fundsPrimary';

  if (webAreaTemplate === 'FUNDS_QUOTES') return 'fundsManager';

  return '';
};

export const fundsSlice = createSlice({
  name: 'fundsSlice',
  initialState,
  reducers: {
    fundsInfoRequest: (state, action) => {
      updateState({ state, fundsDetails: action.payload, isLoading: true });
    },
    fundsInfoSuccess: (state, action) => {
      const { fundsList, ...fundsDetails } = action.payload;

      updateState({
        state,
        fundsDetails,
        isLoading: false,
        fundsList,
      });
    },
    fundsInfoFailure: (state, action) => {
      updateState({ state, fundsDetails: action.payload, isLoading: false });
    },
    resetFundsManager: (state) => {
      state.market.data = [];
    },
    setCurrentTab: (state, action) => {
      if (state.webAreas.length > 0)
        state.currentTab.name = getCurrentTabName(
          state.webAreas[action.payload].template,
        );

      state.currentTab.ord = action.payload;
    },
    setSelectedFundsManagerTitle: (state, action) => {
      let title = {};

      if (Object.keys(action.payload).length > 0) {
        const { symbol, securityExchange, securityType } = action.payload;

        title = state.market.data.find(
          (element) =>
            element.symbol === symbol &&
            element.securityExchange === securityExchange &&
            element.securityType === securityType,
        );
      }

      state.market.selectedTitle = title;
    },
    webAreasRequest: (state) => {
      state.primary.isLoading = true;
      state.market.isLoading = true;
    },
    webAreasSuccess: (state, action) => {
      if (action.payload.length > 0)
        state.currentTab.name = getCurrentTabName(
          action.payload[state.currentTab.ord].template,
        );

      state.webAreas = action.payload;
      state.primary.isLoading = false;
      state.market.isLoading = false;
    },
    webAreasFailure: (state) => {
      state.primary.isLoading = false;
      state.market.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState);
  },
});
